
import { ActionTypes } from './actions';

/* Initial application state
 * NOTE: these are defaults and will be overridden by state derived from the URL.
 */
export const STATE = {
  controlType: "water_level",
  controlsEnabled: true,
  waterLevel: {level: 5, unit: "ft"},
  forecastCtrl: {scenario: "rcp85", sensitivity: 50.0, year: 2100},
  preset: "Medium",
  presetLevels: {Slow: {level: 5, unit: "ft"}, Medium: {level: 5, unit: "ft"}, Fast: {level: 5, unit: "ft"}},
  summary: {},

  place: {},//{id: "california.us", type: "state"},
  placeName: "",
  ssid: "",
  population: "",
  placeContainer: {}, //{"placeType":"country","abbrev":"USA","placeID":"usa","name":"United States of America","tld":"us"},//{name: "New York", placeID: "new-york.us", placeType: "state", abbrev: "NY"},
  mapPosition: {},
  mapCaption: "",
  mapLayer: "sovi",
  stations: [], // [{"dist":150,"name":"Monterey - Monterey Harbor","lon":36.605,"lolev":1,"lev":3,"lat":-121.8866667,"hilev":6,"id":"9413450"}],
  aslrStation: null,
  stationNum: 0,
  q: "",

  forecastType: "NOAA2017_inthi_p50",
  forecastName: "Multi-year",
  forecastMetadata: {},
  protection: "protected",
  impactPct: false,
  impactGroup: "Population",
  impactSubgroup: "All",
  impactSubgroupExclusions: {},
  impact: "Population",
  impactName: "Population",
  placeRanking: [],
  comparisonType: "",
  choroplethBounds: null,
  comparisonParent: "",
  availableComparisons: ["place"],
  defaultComparison: "place",
  eae: [],
  eaeVariable: "Population",
  eaeIsPct: false,
  eaeDerivative: false,
  eaePercentile: 50,
  eaeScenario: "RCP 4.5",

  zillowIsPct: false,
  zillowModel: "DP16",
  zillowPathway: "RCP45",
  zillowPlaceType: "",
  zillowPlaceTypeOptions: [],
  zillowProb: "p50",
  zillowVarType: "Zestimate",
  zillowYear: "2050",
  zillowRanking: [],
  zillowYrBuilt: "All",

  isEmbed: false,
  modalVisible: false,
  modalURL: "",
  modalTitle: "",
  mobileMenuOpen: false,
  downloadFormID: ""
};

/********** Global setting reducers ***********/
export function controlType(state=STATE.controlType, action) {
    if (action.type === ActionTypes.SET_CONTROL_TYPE) {
        return action.controlType;
    } else {
        return state;
    }
}

export function controlsEnabled(state=STATE.controlsEnabled, action) {
  if (action.type === ActionTypes.SET_CONTROLS_ENABLED) {
    return action.enabled;
  } else {
    return state;
  }
}

export function waterLevel(state=STATE.waterLevel, action) {
  if (action.type === ActionTypes.SET_WATER_LEVEL) {
    return action.waterLevel;
  } else {
    return state;
  }
}

export function forecastCtrl(state=STATE.forecastCtrl, action) {
  if (action.type === ActionTypes.SET_FORECAST_CTRL) {
    return action.forecastCtrl;
  } else {
    return state;
  }
}

export function preset(state=STATE.preset, action) {
  if (action.type === ActionTypes.SET_PRESET) {
    return action.preset;
  } else {
    return state;
  }
}

export function presetLevels(state=STATE.presetLevels, action) {
  if (action.type === ActionTypes.SET_PRESET_LEVELS) {
    return action.presetLevels;
  } else {
    return state;
  }
}

export function forecastMetadata(state=STATE.forecastMetadata, action) {
  if (action.type === ActionTypes.SET_FORECAST_METADATA) {
    return action.metadata;
  } else {
    return state;
  }
}

export function summary(state=STATE.summary, action) {
  if (action.type === ActionTypes.SET_SUMMARY) {
    var newState = Object.assign({}, state);
    newState[action.order] = action.data;
    return newState;
  } else {
    return state
  }
}

/*********** Navigational reducers *************/
export function place(state=STATE.place, action) {
  if (action.type === ActionTypes.SET_PLACE) {
    return {
      id: action.placeID,
      type: action.placeType,
    };
  } else {
    return state;
  }
}

export function placeName(state=STATE.placeName, action) {
  if (action.type === ActionTypes.SET_PLACE_NAME) {
    return action.placeName;
  } else {
    return state;
  }
}

export function ssid(state=STATE.ssid, action) {
  if (action.type === ActionTypes.SET_SSID) {
    return action.ssid;
  } else {
    return state;
  }
}

export function population(state=STATE.population, action) {
  if (action.type === ActionTypes.SET_POPULATION) {
    return action.population;
  } else {
    return state;
  }
}

export function placeContainer(state=STATE.placeContainer, action) {
  if (action.type === ActionTypes.SET_PLACE_CONTAINER) {
    return action.placeContainer;
  } else {
    return state;
  }
}

export function stations(state=STATE.stations, action) {
  if (action.type === ActionTypes.SET_STATIONS) {
    return action.stations;
  } else {
    return state;
  }
}

export function aslrStation(state=STATE.aslrStation, action) {
  if (action.type === ActionTypes.SET_ASLR_STATION) {
    return action.aslrStation;
  } else {
    return state;
  }
}

export function stationNum(state=STATE.stationNum, action) {
  if (action.type === ActionTypes.SET_STATION_NUM) {
    return action.stationNum;
  } else {
    return state;
  }
}

export function mapPosition(state=STATE.mapPosition, action) {
  if (action.type === ActionTypes.SET_MAP_POSITION) {
    return {lon: action.lon, lat: action.lat, zoom: action.zoom, bounds: action.bounds};
  } else {
    return state;
  }
}

export function mapCaption(state=STATE.mapCaption, action) {
  if (action.type === ActionTypes.SET_MAP_CAPTION) {
    return action.mapCaption;
  } else {
    return state;
  }
}

export function mapLayer(state=STATE.mapLayer, action) {
  if (action.type === ActionTypes.SET_MAP_LAYER) {
    return action.mapLayer;
  } else {
    return state;
  }
}

export function q(state=STATE.q, action) {
  if (action.type === ActionTypes.SET_QUERY) {
    return action.query;
  } else {
    return state;
  }
}

/************* Component-specific reducers ***********/

export function forecastType(state=STATE.forecastType, action) {
  if (action.type === ActionTypes.SET_FORECAST_TYPE) {
    return action.forecastType;
  } else {
    return state;
  }
}

export function forecastName(state=STATE.forecastName, action) {
  if (action.type === ActionTypes.SET_FORECAST_NAME) {
    return action.forecastName;
  } else {
    return state;
  }
}

export function impactGroup(state=STATE.impactGroup, action) {
  if (action.type === ActionTypes.SET_IMPACT_GROUP) {
    return action.impactGroup;
  } else {
    return state;
  }
}

export function impactSubgroup(state=STATE.impactSubgroup, action) {
  if (action.type === ActionTypes.SET_IMPACT_SUBGROUP) {
    return action.impactSubgroup;
  } else {
    return state;
  }
}

export function impactSubgroupExclusions(state=STATE.impactSubgroupExclusions, action) {
  if (action.type === ActionTypes.SET_IMPACT_SUBGROUP_EXCLUSIONS) {
    return action.impactSubgroupExclusions;
  } else {
    return state;
  }
}

export function impact(state=STATE.impact, action) {
  if (action.type === ActionTypes.SET_IMPACT) {
    return action.impact;
  } else {
    return state;
  }
}

export function impactName(state=STATE.impactName, action) {
  if (action.type === ActionTypes.SET_IMPACT_NAME) {
    return action.impactName;
  } else {
    return state;
  }
}

export function protection(state=STATE.protection, action) {
  if (action.type === ActionTypes.SET_PROTECTION) {
    return action.protection;
  } else {
    return state;
  }
}

export function impactPct(state=STATE.impactPct, action) {
  if (action.type === ActionTypes.SET_IMPACT_PCT) {
    return action.impactPct;
  } else {
    return state;
  }
}

export function isEmbed(state=STATE.isEmbed, action) {
  if (action.type === ActionTypes.SET_EMBED) {
    return action.isEmbed;
  } else {
    return state;
  }
}

export function modalURL(state=STATE.modalURL, action) {
  if (action.type === ActionTypes.SET_MODAL_URL) {
    return action.url;
  } else {
    return state;
  }
}

export function modalVisible(state=STATE.modalVisible, action) {
  if (action.type === ActionTypes.SET_MODAL_VISIBLE) {
    return action.visible;
  } else {
    return state;
  }
}

export function modalTitle(state=STATE.modalTitle, action) {
  if (action.type === ActionTypes.SET_MODAL_TITLE) {
    return action.modalTitle;
  } else {
    return state;
  }
}

export function mobileMenuOpen(state=STATE.mobileMenuOpen, action) {
  if (action.type === ActionTypes.SET_MOBILE_MENU) {
    return action.menuOpen;
  } else {
    return state;
  }
}

export function placeRanking(state=STATE.placeRanking, action) {
  if (action.type === ActionTypes.SET_PLACE_RANKING) {
    return action.placeRanking;
  } else {
    return state;
  }
}

export function comparisonType(state=STATE.comparisonType, action) {
  if (action.type === ActionTypes.SET_COMPARISON_TYPE) {
    return action.comparisonType;
  } else {
    return state;
  }
}

export function choroplethBounds(state=STATE.choroplethBounds, action) {
  if (action.type === ActionTypes.SET_CHOROPLETH_BOUNDS) {
    return action.choroplethBounds;
  } else {
    return state;
  }
}

export function comparisonParent(state=STATE.comparisonParent, action) {
  if (action.type === ActionTypes.SET_COMPARISON_PARENT) {
    return action.comparisonParent;
  } else {
    return state;
  }
}

export function availableComparisons(state=STATE.availableComparisons, action) {
  if (action.type === ActionTypes.SET_AVAILABLE_COMPARISONS) {
    return action.availableComparisons;
  } else {
    return state;
  }
}

export function defaultComparison(state=STATE.defaultComparison, action) {
  if (action.type === ActionTypes.SET_DEFAULT_COMPARISON) {
    return action.defaultComparison;
  } else {
    return state;
  }
}

export function downloadFormID(state=STATE.downloadFormID, action) {
  if (action.type === ActionTypes.SET_DOWNLOAD_FORM_ID) {
    return action.dlFormID
  } else {
    return state;
  }
}

export function eae(state=STATE.eae, action) {
  if (action.type === ActionTypes.SET_EAE) {
    return action.eae;
  } else {
    return state;
  }
}

export function eaeVariable(state=STATE.eaeVariable, action) {
  if (action.type === ActionTypes.SET_EAE_VAR) {
    return action.variable;
  } else {
    return state;
  }
}

export function eaeIsPct(state=STATE.eaeIsPct, action) {
  if (action.type === ActionTypes.SET_EAE_ISPCT) {
    return action.isPct;
  } else {
    return state;
  }
}

export function eaeDerivative(state=STATE.eaeDerivative, action) {
  if (action.type === ActionTypes.SET_EAE_DERIVATIVE) {
    return action.derivative;
  } else {
    return state;
  }
}

export function eaePercentile(state=STATE.eaePercentile, action) {
  if (action.type === ActionTypes.SET_EAE_SENSITIVITY) {
    return action.percentile;
  } else {
    return state;
  }
}

export function eaeScenario(state=STATE.eaeScenario, action) {
  if (action.type === ActionTypes.SET_EAE_SCENARIO) {
    return action.scenario;
  } else {
    return state;
  }
}

export function zillowIsPct(state=STATE.zillowIsPct, action) {
  if (action.type === ActionTypes.SET_ZILLOW_ISPCT) {
    return action.isPct;
  } else {
    return [true, 'true'].includes(state) ? true : false;
  }
}

export function zillowModel(state=STATE.zillowModel, action) {
  if (action.type === ActionTypes.SET_ZILLOW_MODEL) {
    return action.model;
  } else {
    return state;
  }
}

export function zillowPathway(state=STATE.zillowPathway, action) {
  if (action.type === ActionTypes.SET_ZILLOW_PATHWAY) {
    return action.pathway;
  } else {
    return state;
  }
}

export function zillowPlaceType(state=STATE.zillowPlaceType, action) {
  if (action.type === ActionTypes.SET_ZILLOW_PLACE_TYPE) {
    return action.placeType;
  } else {
    return state;
  }
}

export function zillowPlaceTypeOptions(state=STATE.zillowPlaceTypeOptions, action) {
  if (action.type === ActionTypes.SET_ZILLOW_PLACE_TYPE_OPTIONS) {
    return action.options;
  } else {
    return state;
  }
}

export function zillowProb(state=STATE.zillowProb, action) {
  if (action.type === ActionTypes.SET_ZILLOW_PROB) {
    return action.prob;
  } else {
    return state;
  }
}

export function zillowRanking(state=STATE.zillowRanking, action) {
  if (action.type === ActionTypes.SET_ZILLOW_RANKING) {
    return action.ranking;
  } else {
    return state;
  }
}

export function zillowVarType(state=STATE.zillowVarType, action) {
  if (action.type === ActionTypes.SET_ZILLOW_VAR_TYPE) {
    return action.vartype;
  } else {
    return state;
  }
}

export function zillowYear(state=STATE.zillowYear, action) {
  if (action.type === ActionTypes.SET_ZILLOW_YEAR) {
    return action.year;
  } else {
    return state;
  }
}

export function zillowYrBuilt(state=STATE.zillowYrBuilt, action) {
  if (action.type === ActionTypes.SET_ZILLOW_YR_BUILT) {
    return action.year;
  } else {
    return state;
  }
}

